import { IUser } from "@interfaces/IUser";
import { CacheService } from "@services/cache.Service";
import { UsersService } from "@services/users.service";
import { IPlannedRouteNote } from "@tms/_models/IPlannedRouteNote";

export class PlannedRouteNoteService {

    plannedRouteNoteServiceCache = 'plannedRouteNoteServiceCache';

    static $inject = ["$http", "$q", "cacheService",  "usersService"];

    constructor(
        private readonly $http: angular.IHttpService,
        private readonly $q: angular.IQService,
        private readonly cacheService: CacheService,
        private readonly usersService: UsersService,
    ) {
        this.cacheService.createCache(this.plannedRouteNoteServiceCache, { maxAge: 5 * 60 * 1000 });
    }

    getNotesForPlannedRoutes(start: moment.Moment, end: moment.Moment, invalidateCache = false, unsafe=false): angular.IPromise<IPlannedRouteNote[]> {
        return this.cacheService.getOrRetrieveData(this.plannedRouteNoteServiceCache, () => this.getNotesForPlannedRoutesFromDatabase(start, end), invalidateCache, unsafe);
    }

    getNotesForPlannedRoutesFromDatabase(start: moment.Moment, end: moment.Moment): angular.IPromise<IPlannedRouteNote[]> {
        const notesPromise = this
            .$http({
                url: `/api/tms/notes/plannedroutes?start=${start.toISOString()}&end=${end.toISOString()}`,
                method: "GET"
            })
            .then((response: angular.IHttpPromiseCallbackArg<IPlannedRouteNote[]>) => {
                return response.data;
            });

        const usersPromise = this.usersService.getUsers({ includeAdmins: true });

        return this.$q
            .all([notesPromise, usersPromise])
            .then(([notes, users]) => {
                this.mapUsersToNotes(notes, users);
                return notes;
            });
    }

    getNotesForPlannedRoute(routeId: number): angular.IPromise<IPlannedRouteNote[]> {
        const notesPromise = this
            .$http({
                url: `/api/tms/notes/${routeId}`,
                method: "GET"
            })
            .then((response: angular.IHttpPromiseCallbackArg<IPlannedRouteNote[]>) => {
                return response.data;
            });

        const usersPromise = this.usersService.getUsers({ includeAdmins: true });

        return this.$q
            .all([notesPromise, usersPromise])
            .then(([notes, users]) => {
                this.mapUsersToNotes(notes, users);
                return notes;
            });
    }

    addPlannedRouteNotes(routeId: number, note: IPlannedRouteNote) {
        return this
            .$http({
                url: `/api/tms/notes/${routeId}`,
                method: "POST",
                data: note
            })
            .then(response => {
                return response.data;
            });
    }

    private mapUsersToNotes(notes: IPlannedRouteNote[], users: IUser[]) {
        if (!notes) {
            return;
        }
        notes.forEach(note => {
            if (!note.UserId) {
                note.author = 'SYSTEM';
                return;
            }
            const noteUser = users.find(u => {
                return u.Id === note.UserId;
            });
            if (noteUser) {
                note.user = noteUser;
                note.author = noteUser.AccountUserMappings[0]?.Name || 'Unknown User';
                return;
            }
        });
    }

}
